// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';



import Menu from '../_modules/menu/menu';
import News from '../_modules/news/news';
import Hero from '../_modules/hero/hero';
import Calculator from '../_modules/calculator/calculator';
import Login from '../_modules/login/login';
import date from '../_modules/date/date';
import Info from '../_modules/info/info';
import Warrant from '../_modules/warrant/warrant';
import Payment from '../_modules/payment/payment';
import YourFinesList from '../_modules/yourFinesList/yourFinesList';
import UpcomingPaymentArrangements from '../_modules/upcomingpaymentarrangements/upcomingpaymentarrangements';
import OnlineFeedback from '../_modules/OnlineFeedback/OnlineFeedback';
import FineDetails from '../_modules/fineDetails/fineDetails';
import OpenMattersReport from '../_modules/openmattersreport/openmattersreport';
import Topbar from '../_modules/topbar/topbar';
import Modal from '../_modules/modal/modal';

$(() => {
  if(window.location.href.indexOf('Your-Fines/Upcoming-Payment-Arrangement') > -1){
    new UpcomingPaymentArrangements();
  }
 
  var onlineFeedback = new OnlineFeedback();

  new Menu();
  new News();
  new Hero();
  new Topbar();
  new Modal();
  var $mobile = '767',
    $tablet = '1024';
  //form ajaxOptions
  var buttontext;
  var onlineEnquiryType = getUrlParameter('type');
  var onlineEnquirySub = getUrlParameter('sub');
  // enable / disable CAPTCHA for all forms at front end, can turn it off when debug locally
  $('.online-enquiry-form,.online-feedback-form,.prison-program-form').find(':submit').prop('disabled', false);
  var capEnabled = true;
  var globalFilesArray = new DataTransfer();
  $('.online-enquiry-form,.online-feedback-form,.prison-program-form').find(':submit').click(function(){
    // console.log('submitted');
    var option = $('#other-options').val();
    var inputs;
    if ( option && option != '') {
      inputs  = $('#EnquiryType,.covidConcessionSection').find('input,textarea');
      // clear field values in other froms if submitting Upload Concession Form
      $('.online-enquiry-form > .enquiry-details, .online-feedback-form').find('input,textarea,select').each(function(){
        if ($(this).val() != '') {
          $(this).val('');
        }
      });
    }
    else {
      inputs = $('.online-enquiry-form > #EnquiryType, .online-enquiry-form > .enquiry-details, .online-enquiry-form > #attachmentSection,.online-feedback-form,.prison-program-form').find('input,textarea');
      // inputs  = $('.online-enquiry-form,.online-feedback-form').find('input,textarea');
    }
    inputs.each(function(){
      var value = $(this).val();
	  if (this.name !== 'Attachments')
		  //replace it with forwardslash for security reasons
		  $(this).val(value.replace(/\\/g, '/'));
    });
  });

  if (window.location.href.indexOf('?unsubscribe=mobile') > -1) {
    $('<div class=\'unsubscribe\' style=\'position:fixed; top:0;left:0;right:0;height:auto;width:100%;background:#f9fbfc;z-index:20000;flex-direction: row;font-size:16px;text-align:center\'><p style=\'display:inline-block\'>You have successfully unsubscribed the mobile notification.</p><div style=\'float:right; padding: 18px 0;display:inline-block;margin-right:100px\'><a href=\'/\'  >Close</a></div></div>').insertBefore('.site-container-home');
    $('body.home').css('padding-top', '56px');
  }
  if (window.location.href.indexOf('?unsubscribe=email') > -1) {
    $('<div class=\'unsubscribe\' style=\'position:fixed; top:0;left:0;right:0;height:auto;width:100%;background:#f9fbfc;z-index:20000;flex-direction: row;font-size:16px;text-align:center\'><p style=\'display:inline-block\'>You have successfully unsubscribed the email notification.</p><div style=\'float:right; padding: 18px 0;display:inline-block;margin-right:100px\'><a href=\'/\'  >Close</a></div></div>').insertBefore('.site-container-home');
    $('body.home').css('padding-top', '56px');
  }

  if (window.location.href.indexOf('?s=timeout') > -1 && window.location.href.indexOf('Your-Fines-Login') > -1) {
    $('<div class=\'session_timeout\' style=\' top:0;left:0;right:0;height:auto;width:100%;background:#f9fbfc;z-index:20000;flex-direction: row;font-size:16px;text-align:center\'><p class=\'icon-exclamation pink\' style=\'display:inline-block\'>Your session has timed out. Please login again</p><div style=\'float:right; padding: 18px 0;display:inline-block;margin-right:100px\'></div></div>').insertBefore('.page-container__wrapper section');
    // $("body").css("padding-top", "56px");
  }
  // payment success page
  if (window.location.href.indexOf('/Payment-Success') > -1 && window.location.href.indexOf('?communityCode=') > -1) {
    history.replaceState({}, null, '/'+window.location.pathname.split('/').slice(-1));
  }

  $('#DismissTOMessage').on('click', function (e) {
    e.preventDefault();

    $('.session_timeout').fadeOut('1000', function () {
      $('body').css('padding-top', '0px');
    });
  });

  $('#hideoption').on('click', function () {
    $('.notice-option').css('display', 'none');
    $('.btn.btn-next').text('Continue');
    buttontext = 'Continue';
  });
  $('#showoption').on('click', function () {
    $('.notice-option').css('display', 'block');
    $('.btn.btn-next').text('Save and continue');
    buttontext = 'Save and continue';
  });
  $(document).ready(function () {
    $('.btn.btn-next').text(buttontext);
  });
  $('#hidedetail').on('click', function () {
    $('.financial-detail').css('display', 'none');
  });
  $('#showdetail').on('click', function () {
    $('.financial-detail').css('display', 'block');
  });

  $('.included-fines').on('click', function () {
    $('.modal-holder').css('display', 'block');
  });
  $('#edit').on('click', function () {
    $('.modal-holder').css('display', 'none');
  });
  //GA event
  $('.home .pay-holder button').on('click', function () {
    ga('send', 'event', 'Pay', 'payment', 'Payment homepage');
  });
  $('.PayButtonForm button').on('click', function () {
    ga('send', 'event', 'Pay', 'payment', 'Payment calculator');
  });
  
  // Toolbar
  $('#goback').on('click', function (e) {
    window.history.back();
  });
  $('#print').on('click', function (e) {
    window.print();
  });
  var width = $(window).width();
  var isResized;
  $(window).resize(function () {
    if ($(window).width() != width) {
      width = $(window).width();
      clearTimeout(isResized);
      isResized = setTimeout(windowHasResized, 200);
    }
  });

  function windowHasResized() {
    ulTabItemHeight();
    ulTabsSize();
    if ($(window).width() < 1025) {
      accordion('.fines-table');
      //accordion('#OutstandingFineList');
      //accordion('#PaymentArrangementList');
      //accordion('#ClosedFinesList');
    }
  };

  $('html').attr('class', 'js');

  $('#up').on('click', function () {
    if ($(this).closest('body').hasClass('home')) {
      var target = $('#more-info');
      $('html,body').animate({
        scrollTop: target.offset().top
      }, 'slow');
    }
    else {
      $('html,body').animate({
        scrollTop: 0
      }, 'slow');
    }

  });
  if ($(window).width() < 1025) {
    $('.slide-1_1').removeClass('active');
  }
  $('.slide-1 .more.icon-arrow').after('<a id="show-cal" href="javascript:void(0)" title="Calculate the additional fees of not paying" class="btn-cost icon-arrow">What&#39;s the cost of not paying?</a>');
  // CONTENT PAGE
  if ($('.tabs').length > 0) {
    if (innerWidth >= $mobile) {
      var $tabNo = $('.tabs > li').length;

      switch ($tabNo) {
      case 2:
        $('.tabs').addClass('two-tabs');
        break;
      case 3:
        $('.tabs').addClass('three-tabs');
        break;
      default:
        break;
      }

      $('.tabs .head').on('click', function () {
        $('.tabs .active').removeClass('active');
        $(this).parent('li').addClass('active');
      });
    }
    if (innerWidth <= $mobile) { // ACCORDION ON MOBILE
      accordion('.tabs');
    }
  }

  if ($('.accordion').length > 0) {
    accordion('.accordion');
  }

  if ($('.table').length > 0) {
    if (innerWidth <= $mobile) { // ACCORDION ON MOBILE
      accordion('.table');
    }
  }

  // SEARCH BUTTON
  $('#menu #siteSearch').on('click', function (event) {
    event.preventDefault();
    if (!$('#menu #term').val() == '') {
      var term = $('#menu #term').val();
      window.location.href = window.location.protocol + '//' + window.location.host + '/Search?term=' + term;
    }
  });
  $('.page-container #siteSearch').on('click', function (event) {
    event.preventDefault();
    if (!$('.page-container #searchTxt').val() == '') {
      var term = $('.page-container #searchTxt').val();
      window.location.href = window.location.protocol + '//' + window.location.host + '/Search?term=' + term;
    }
  });
  //CONTACT PAGE MAP
  $('.map').click(function () {
    $('.map iframe').css('pointer-events', 'auto');
  });
  $('.map').mouseleave(function () {
    $('.map iframe').css('pointer-events', 'none');
  });

  //YOUR FINES

  $('.logout-link').on('click', function (e) {
    e.preventDefault();
    var apiTarget = window.location.origin + '/api/sitecore/Login/Logout';
    $.ajax({
      method: 'POST',
      url: apiTarget,
      success: function (Result) {
        if (Result.result === true) {
          window.location.href = window.location.origin + '/';
        }

      },
      error: function (xhr, ajaxOptions, thrownError) { }
    });
  });

  if ($(window).width() < 1025) {
    accordion('.fines-table');
  }

  if ($('.fine-details').length > 0) {
    if (innerWidth <= $tablet) { // ACCORDION ON TABLET DOWN
      //rearrange content
      var fineDetails = $('.fine-details-holder').html();
      $('.fine-details-holder').remove();

      $('.two-thirds').prepend(fineDetails);
    }
  }

  if ($('.cost-holder').length > 0) {
    if (innerWidth <= $tablet) {
      $('.cost-holder h4').click(function () {
        $('.cost-holder').addClass('show');
      });
      // $(".cost-table .body").hide();
      $('.cost-table .head').append('<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span></span>');

      $('.cost-table .head').click(function () {
        $(this).next('.body').slideToggle();
      });
    }
  }
  $('.accordion .head .icon-accordion-toggle').click(function () {
    $(this).parent().next('.body').slideToggle();
  });
  $('.warrant-fine input[type="checkbox"]').prop('checked', true);
  $('p.warrant-txt').css('display', 'block');
  $('.warrant-fine input[type="checkbox"]').on('click', function () {
    if ($('.warrant-fine input[type="checkbox"]').not(':checked')) {
      $('.included-fines').text('Save and continue');
      $('p.warrant-txt.sub-txt').css('display', 'none');
      $('.warrant-fine>li:first-child').css('display', 'none');
    }
    if ($('.warrant-fine input[type="checkbox"]').prop('checked')) {
      ($('.included-fines').text('Continue'));
      $('p.warrant-txt.sub-txt').css('display', 'block');
      $('.warrant-fine>li:first-child').css('display', 'list-item');
    }
  });
  //reference scrolling to footer element
  $('.reference-link').click(function () {
    $('html, body').animate({
      scrollTop: $('.reference-first').offset().top - 100
    }, 400);
    return false;
  });

  function accordion(controller) {
    //ADD UP DOWN ARROW
    $(controller + ' .head').append('<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span></span>');
    //OPEN CONTENT MARKED AS "ACTIVE"
    $(controller + ' li .body').slideUp();
    $(controller + ' .active .body').slideDown();

    // OPEN & CLOSE accordion
    $('body')
      .off('click', controller + ' .head')
      .on('click', controller + ' .head', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).next('.body').slideUp();
        }
        else {
          // Getting the height of body of the current open accordion
          var openedBody = $(controller + ' li a.active').next('.body');
          var height = openedBody.length > 0 ? openedBody.height() : 0;

          $(controller + ' li.active').removeClass('active');
          $(controller + ' li a.active').removeClass('active');
          $(this).addClass('active');
          $(controller + ' li a:not(.active)')
            .next('.body')
            .slideUp();
          $(this).next('.body').slideDown();

          $('html, body').animate(
            {
              scrollTop: $(this).offset().top - height,
            },
            400
          );
        }
      });
  }

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  new Calculator();
  new Info();
  new Warrant();
  new Login();
  new Payment();
  new date();
  new YourFinesList();
  new FineDetails();  
  new OpenMattersReport();
  //target help
  if ($('.help-holder').length > 0) {

    $('.help, .obn-help, .feedbackhelp, .help-link').on('click', function () {
      var data = $(this).attr('data-help');
      $('.help-holder[name="' + data + '"]').css('display', 'block');
    });
    $('.close').on('click', function () {
      $('.help-holder').css('display', 'none');
    });
    if (innerWidth <= $tablet) { // ACCORDION ON TABLET DOWN
      accordion('.help-table');
    }
    var $no = $('.help-table li').length;
    switch ($no) {
    case 3:
      $('.help-table').addClass('two-help');
      break;
    case 4:
      $('.help-table').addClass('three-help');
      break;
    default:
      break;
    }
  }

  $('.fade').on('click', function () {
    $('.fade').parent().css('display', 'none');

  });
  //tabs
  function ulTabItemHeight() {
    var highestItem = 0;
    $('ul.tabs > li').each(function () {
      $(this).children('.head').height('auto');
      if ($(this).children('.head').height() > highestItem) {
        highestItem = $(this).children('.head').height();
      }
    });
    $('ul.tabs > li').each(function () {
      $(this).children('.head').height(highestItem);
      $(this).children('.body').css('padding-top', highestItem + 90 + 'px');
    });
    if ($(window).width() < 768) {
      $('ul.tabs > li').each(function () {
        $(this).children('.head').removeAttr('style');
        $(this).children('.body').css('padding-top', '');
      });
    }
  }

  function ulTabsSize() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      if ($('ul.tabs > li').length > 0) {
        var leftPosition = 0;
        var width = 100 / $('ul.tabs > li').length;
        $('.tabs > li .head').css('width', width + '%');
        $('ul.tabs > li').each(function () {
          $(this).children('.head').css('left', leftPosition + '%');
          leftPosition = leftPosition + width;
        });
      }
    }
  };
  //active tab anchor
  function activeTab() {
    if ($('ul.tabs > li').length > 0) {
      var totalItems = ($('ul.tabs > li').length);
      var tabItem = window.location.hash.split('#');
      tabItem = tabItem[tabItem.length - 1];
      if (tabItem && tabItem <= totalItems) {
        $('ul.tabs > li').removeClass('active');
        $('ul.tabs > li:eq(' + (tabItem - 1) + ')').addClass('active');
      }
    }

  }
  //active accordion anchor
  function activeAccordion() {
    if ($('ul.accordion > li').length > 0) {
      var accordionId = window.location.hash.split('#');
      accordionId = accordionId[accordionId.length - 1];
      if (accordionId) {
        $('ul.accordion > li.active .body').slideUp();
        $('ul.accordion > li.active').removeClass('active');
        $('ul.accordion > li #' + accordionId).parent().addClass('active');
        $('ul.accordion > li #' + accordionId).parent().children('.body').slideDown();
      }
    }
  }
  ulTabsSize();
  ulTabItemHeight();
  activeTab();
  activeAccordion();

  //home page landing

  if($('#Identifier').length > 0 && window.location.href.indexOf('/pay?identifier') > -1){
    var homeidentifier = getUrlParameter('identifier');
    $('#Identifier').val(homeidentifier ? homeidentifier : '');

  }
  if($('#Identifier').length > 0 && window.location.href.indexOf('/Your-Fines/Your-Fines-Login?identifier') > -1){
    var loginidentifier = getUrlParameter('identifier');
    $('input[name=\'Identifier\']').val(loginidentifier ? loginidentifier : '');

  }

  // $("form").append('<input type="hidden" name="currentPage" value="'+window.location.href+'">');
  //online enquiry form

  function OnlineEnquiryCountryFilter() {
    $('#PostalCountry').find('option[value="AUS"]').prop('selected', true);
    $('#ResidentialCountry').find('option[value="AUS"]').prop('selected', true);
    $('#CountryOfIssue').find('option[value="AUS"]').prop('selected', true);
    $('#StateOfIssue').find('option[value="VIC"]').prop('selected', true);
    $('#PostalState').find('option[value="VIC"]').prop('selected', true);
    $('#PhoneNumber').attr('pattern', '[0-9]{8,14}');
    $('#PhoneNumber').attr('data-message', 'Please enter a valid phone number. Only digits are allowed');
    $('#PostalCountry').on('change', function () {
      if ($(this).val() == 'AUS') {
        $('#PostalState').siblings('label').html('State or territory*');
        $('#PostalState').show().removeAttr('disabled');
        $('#PostalStateInternational').hide().attr('disabled', '');
        $('#Postcode').attr('pattern', '[0-9]{4}');
        $('#Postcode').attr('maxlength', '4');
      }
      else {
        $('#PostalState').siblings('label').html('State or territory');
        $('#PostalState').hide().attr('disabled', '');
        $('#PostalStateInternational').show().removeAttr('disabled');
        $('#Postcode').attr('type', 'text');
        $('#Postcode').attr('maxlength', '10');
        $('#Postcode').removeAttr('pattern');
      }
    }).change();
    $('#ResidentialCountry').on('change', function () {
      if ($(this).val() == 'AUS') {
        $('#ResidentialState').show().removeAttr('disabled');
        $('#ResidentialStateInternational').hide().attr('disabled', '');
        $('#ResidentialPostcode').attr('pattern', '[0-9]{4}');
        $('#ResidentialPostcode').attr('maxlength', '4');
      }
      else {
        $('#ResidentialState').hide().attr('disabled', '');
        $('#ResidentialStateInternational').show().removeAttr('disabled');
        $('#ResidentialPostcode').attr('type', 'text');
        $('#ResidentialPostcode').attr('maxlength', '10');
        $('#ResidentialPostcode').removeAttr('pattern');
      }
    }).change();
  };
  OnlineEnquiryCountryFilter();

  //hide country of issue and international lisence at start
  if($('#LicenceNumber').length > 0 ){
    if($('#LicenceNumber').val().trim() == ''){
      $('.state-of-issue').hide();
    
      $('.country-of-issue select').attr('disabled',true);
  
      $('.country-of-issue').hide();
      $('.state-of-issue select').attr('disabled',true);
  
    }
    else{
      if ($('.int-licence').prop('checked')) {
        $('.country-of-issue').show();
        $('.country-of-issue select').removeAttr('disabled');
      }
      else {
        $('.state-of-issue').show();
        $('.state-of-issue select').removeAttr('disabled');
  
      }
    }
  }



  $('.int-licence').change(function () {
 
    if($('#LicenceNumber').val().trim() != ''){
      if (this.checked) {
        $('.state-of-issue').hide();
        $('.state-of-issue select').attr('disabled',true);
        $('.country-of-issue').show();
        $('.country-of-issue select').removeAttr('disabled');
      }
      else {
        $('.state-of-issue').show();
        $('.state-of-issue select').removeAttr('disabled');
      
        $('.country-of-issue').hide();
        $('.country-of-issue select').attr('disabled',true);
     
      }
    }
  });

  $('#LicenceNumber').on('input', function(){
  // on change the state of issue field will be hidden dynamically
    if($(this).val().trim() != ''){
      if ($('.int-licence').prop('checked')) {
        $('.country-of-issue').show();
        $('.country-of-issue select').removeAttr('disabled');
      }
      else {
        $('.state-of-issue').show();
        $('.state-of-issue select').removeAttr('disabled');
      }
    }
    else{
      $('.state-of-issue').hide();
      $('.state-of-issue select').attr('disabled',true);
      $('.country-of-issue').hide();
      $('.country-of-issue select').attr('disabled',true);
    }
  });
  // clear out attachments when reloaded
  if($('.online-enquiry-form').length > 0 && $('#Attachments').length > 0){
    $('#Attachments').val('');
  }
  var createAllErrorsPrisonProgram = function () {
    var form = $('.prison-program-form');
    var errorList = $('div.error-message', form);
    var invalid = false;
    errorList.hide();
		
    var showAllErrorMessagesPrisonProgram = function () {
      invalid = false;
      errorList.empty();
      $('.error').removeClass('error');

      //Find all invalid fields within the form.
      form.find(':invalid').each(function (index, node) {
        $(this).addClass('error');
        invalid = true;
        
        if($(this).attr('data-message') != 'undefined' && $(this).attr('data-message')){
          errorList
            .show()
            .append('<p class="icon-exclamation">' + $(this).attr('data-message') + '</p>');
        }
      });
   
      if ($('#residential-address').val() == '' && $('#postal-address').val() == '' && $('#postal-address-line-1').val() == '' && $('#residential-address-line-1').val() == '' && $('#EmailAddress').val() == '') {
        $('#residential-address').addClass('error');
        $('#residential-address-line-1').addClass('error');
        $('#postal-address').addClass('error');
        $('#postal-address-line-1').addClass('error');
        $('#EmailAddress').addClass('error');
        invalid = true;
        errorList
          .show()
          .append('<p class="icon-exclamation">Please enter at least one of the following: <ul style="margin-top: 0px;padding-left: 36px;margin-bottom: 0px;"><li style="line-height: 1;">Residential address</li><li style="line-height: 1;">Postal address</li><li style="line-height: 1;">Email address</li><ul>');
      }
      if (!isCaptchaChecked() && capEnabled) {
        invalid = true;
        errorList
          .show()
          .append('<p class="icon-exclamation">Please complete CAPTCHA</p>');
      }
    };
    $('.prison-program-form input, .prison-program-form textarea').focusout(function(){
      if(!$(this).is(':invalid')){
        $(this).removeClass('error');
      }
    });
    $('.prison-program-form select').change(function(){
      $(this).removeClass('error');
    });
    $('.prison-program-form input').change(function(){
      if($(this).attr('id') == 'residential-address' || $(this).attr('id') == 'postal-address' || $(this).attr('id') == 'postal-address-line-1' || $(this).attr('id') == 'residential-address-line-1' || $(this).attr('id') == 'EmailAddress'){
        $('#residential-address').removeClass('error');
        $('#postal-address').removeClass('error');
        $('#postal-address-line-1').removeClass('error');
        $('#residential-address-line-1').removeClass('error');
        $('#EmailAddress').removeClass('error');
      }
      
    });

    $('.prison-program-form .btn').on('click', function () {

      if(!$(this).hasClass('pay')){
        showAllErrorMessagesPrisonProgram();
        if (invalid) {
          $('html,body').animate({
            scrollTop: $(errorList).offset().top - 100
          }, 'fast');
          return false;
        }
      }
      
    });

  };
  
  createAllErrorsPrisonProgram();
  function isCaptchaChecked() {
    return grecaptcha && grecaptcha.getResponse().length !== 0;
  }
  let onlineGenericFileSize = 3145728;
  let onlineGenericFileNum = 5;
  let onlineGenericFileDescription = 'You can upload a maximum of 5 files, each file should be less than 3MB.';
  let attachmentConfigData;
  
  if($('.online-enquiry-form').length > 0){
    getAttachmentConfig();
  }
  function getAttachmentConfig() {
    return $.ajax({
      url: window.location.origin + '/api/sitecore/File/GetValidFilesConfig',
      type: 'GET',
      async: false,
      dataType: 'json',
      success: function (data,status,xhr) {
        attachmentConfigData = data;
        let onlineGeneric = getSelectedFilesConfig('OnlineGeneric');
        onlineGenericFileSize = onlineGeneric.allowedFileSize;
        onlineGenericFileNum = onlineGeneric.allowedNumOfFiles;
        onlineGenericFileDescription = onlineGeneric.description;
      },
      error: function (jqXhr, textStatus, errorMessage) {
        console.log(errorMessage);
      }
    });
  }



  function getSelectedFilesConfig(option) {
    // if option is selected
    let formType;
    if (option && attachmentConfigData.length) {
      switch (option) {
      case 'UploadCovidConcession':
      case 'OnlineEnquirySeatbelt':
        formType = 'OnlineCovid';
        break;
      case 'UploadFinancialCircumstances':
        formType = 'OnlineFinancial';
        break;
      case 'UploadInfringementExtension':
      formType = 'OnlineInfringement';
      break;
      default:
        break;
      }
    }

    if (formType) {
      const foundAttachmentConfig = attachmentConfigData.find((value) => value.FormType === formType);
      if (foundAttachmentConfig) {
        return {
          allowedNumOfFiles: foundAttachmentConfig.MaxAttachments,
          allowedFileSize: foundAttachmentConfig.FileSize,
          description:foundAttachmentConfig.Description
        };
      }
    }

    // if no formType given, return generic configurations
    return {
      allowedNumOfFiles: onlineGenericFileNum,
      allowedFileSize: onlineGenericFileSize,
      description: onlineGenericFileDescription
    };
  }

  function bytesToSize(bytes) {
    if (bytes === 0) return 'n/a';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes}`;
    return `${(bytes / (1024 ** i)).toFixed(1)}`;
  }

  var createAllErrors = function () {
    var form = $('.online-enquiry-form').length ? $('.online-enquiry-form') : $('.online-feedback-form');
    var errorList = $('div.error-message', form);
    var covidConcessionErrorList = $('div.file-section-error-message', form);
    var invalid = false;
    errorList.hide();
    covidConcessionErrorList.hide();
	
    var fileUploadFailure =  $('p.file-failure');	
    if (fileUploadFailure.length > 0) {
      errorList.show();
      covidConcessionErrorList.show();
    }
    var showAllErrorMessages = function () {
      invalid = false;
      errorList.empty();
      $('.error').removeClass('error');
      var allInvalidWithoutCOVIDForm = $('#EnquiryType, .enquiry-details, #attachmentSection').find(':invalid');
      //Find all invalid fields within the form.
      allInvalidWithoutCOVIDForm.each(function (index, node) {
        $(this).addClass('error');
        invalid = true;
        
        if($(this).attr('data-message') != 'undefined' && $(this).attr('data-message')){
          errorList
            .show()
            .append('<p class="icon-exclamation">' + $(this).attr('data-message') + '</p>');
        }
      });
      if ($('#EmailAddress').val() != $('#ConfirmEmailAddress').val()) {
        $('#ConfirmEmailAddress,#EmailAddress ').addClass('error');
        invalid = true;
        errorList
          .show()
          .append('<p class="icon-exclamation">Email addresses must match</p>');
      }

	  if ((!$('#other-options').is(':disabled') && $('#other-options').val() == '') || (!$('#followup-options').is(':disabled') && $('#followup-options').val() == '')) {
		  $('#followup-options,#other-options').addClass('error');
		  invalid = true;
		  errorList
		  	  .show()
			  .append('<p class="icon-exclamation">Please select a Request type</p>');
	  }

      var val = $('#Message');
      if (val.length > 0) {
        if ($('#Message').val().length > 5000) {
          $('#Message').addClass('error');
          invalid = true;
          errorList
            .show()
            .append('<p class="icon-exclamation">Character limit reached. If you wish to include more information please attach a Word or text document</p>');
        }
      }
      var $size = 0;
      var $validFile = true;
      var _validFileExtensions = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/msword','image/jpeg','image/png','application/pdf','text/plain'];  
	  	//file size and extension check here
      $('.inputfile').each(function () {
        if ($(this).val() != '') {
          var i;
          for (i = 0; i < this.files.length; i++) { 
				  $size += this.files[i].size;
				  if (!_validFileExtensions.includes(this.files[i].type) || this.files[i].name.endsWith('.rtf')){
					  $validFile = false;
				  }
          }				
        }
			
        if (this.files.length > onlineGenericFileNum){
          invalid = true;
          errorList
            .show()
            .append('<p class="icon-exclamation">A maximum of '+ onlineGenericFileNum +' files can be attached.</p>');
        }
        else if ($size > onlineGenericFileSize){
          invalid = true;
          errorList
            .show()
            .append('<p class="icon-exclamation">One or more files is too large. Files should be '+parseFloat(bytesToSize(onlineGenericFileSize))+'MB or less.</p>');
        }
        else if (!$validFile){
          invalid = true;
          errorList
            .show()
            .append('<p class="icon-exclamation">One or more attachments is not an allowed file type. Only PDF, Word, Excel, PNG, JPG, Text are allowed.</p>');
        }
			 
      });
    
      if (!isCaptchaChecked() && capEnabled) {
        invalid = true;
        errorList
          .show()
          .append('<p class="icon-exclamation">Please complete CAPTCHA</p>');
      }
    };
    function checkCovidEligibility(obNumber) {
      return $.ajax({
        url: window.location.origin + '/api/sitecore/OnlineEnquiry/IsEligibleForCovidConcession',
        type: 'POST',
        async: false,
        dataType: 'json',
        data:  {
          'obligationNumber': obNumber
        },
      });
    }

    function checkSeatbeltEligibility(obNumber) {
      return $.ajax({
        url: window.location.origin + '/api/sitecore/OnlineEnquiry/IsEligibleForSeatbeltExemption',
        type: 'POST',
        async: false,
        dataType: 'json',
        data:  {
          'obligationNumber': obNumber
        },
      });
    }

    function checkFinancialCircumstancesEligibility(obNumber) {
      return $.ajax({
        url: window.location.origin + '/api/sitecore/OnlineEnquiry/IsEligibleForFinancialCircumstances',
        type: 'POST',
        async: false,
        dataType: 'json',
        data:  {
          'obligationNumber': obNumber
        },
      });
    }
    function checkInfringementExtensionEligibility(obNumber) {
      return $.ajax({
        url: window.location.origin + '/api/sitecore/OnlineEnquiry/IsEligibleForInfringementExtension',
        type: 'POST',
        async: false,
        dataType: 'json',
        data:  {
          'obligationNumber': obNumber
        },
      });
    }
    var showCovidConcessionSectionErrorMessages = function () {
      var form = $('.online-enquiry-form .covidConcessionSection');
      invalid = false;
      // obligation number field
      var COVIDReferenceNumber =  $('#COVIDReferenceNumber');
      var option = $('#other-options').val();
      covidConcessionErrorList.empty();
      $('.error').removeClass('error');
      
      //Find all invalid fields within the form.
      form.find(':invalid').each(function (index, node) {
        $(this).addClass('error');
        invalid = true;
        
        if($(this).attr('data-message') != 'undefined' && $(this).attr('data-message')){
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation">' + $(this).attr('data-message') + '</p>');
        }
      });
      var tenDigitsReg = /^\d{10}$/;
      var isTenDigits = tenDigitsReg.test($('#COVIDReferenceNumber').val());
      if(!isTenDigits && $('#COVIDReferenceNumber').val().length !== 0){
        invalid = true;
        covidConcessionErrorList
          .show()
          .append('<p class="icon-exclamation">Please enter a valid 10-digit obligation number.</p>');
      }
      if (!isCaptchaChecked() && capEnabled) {
        invalid = true;
        covidConcessionErrorList
          .show()
          .append('<p class="icon-exclamation">Please complete CAPTCHA</p>');
      }
      if(!invalid && COVIDReferenceNumber.val() !== '' && option == 'UploadCovidConcession'){
        $.when(checkCovidEligibility(COVIDReferenceNumber.val())).done(function(res){
          if(!res){
            COVIDReferenceNumber.addClass('error');
            invalid = true;
            covidConcessionErrorList
              .show()
              .append('<p class=\'icon-exclamation\'>The obligation number isn\'t eligible for COVID concession.</p>');
          }
        }).fail(function (response) {
          COVIDReferenceNumber.addClass('error');
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class=\'icon-exclamation\'>The obligation number isn\'t eligible for COVID concession.</p>');
        });
      }

      if(!invalid && COVIDReferenceNumber.val() !== '' && option == 'OnlineEnquirySeatbelt'){
        $.when(checkSeatbeltEligibility(COVIDReferenceNumber.val())).done(function(res){
          if(!res){
            COVIDReferenceNumber.addClass('error');
            invalid = true;
            covidConcessionErrorList
              .show()
              .append('<p class=\'icon-exclamation\'>The obligation number isn\'t eligible for Seatbelt exemption.</p>');
          }
        }).fail(function (response) {
          COVIDReferenceNumber.addClass('error');
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class=\'icon-exclamation\'>'+response.responseJSON.Error +'</p>');
        });

      }

      // Generate errors for statement of financial circumstances
      if(!invalid && COVIDReferenceNumber.val() !== '' && option == 'UploadFinancialCircumstances'){
        $.when(checkFinancialCircumstancesEligibility(COVIDReferenceNumber.val())).done(function(res){
          if(!res){
            COVIDReferenceNumber.addClass('error');
            invalid = true;
            covidConcessionErrorList
              .show()
              .append('<p class=\'icon-exclamation\'>Please enter a valid obligation or infringement number.</p>');
          }
        }).fail(function (response) {
          COVIDReferenceNumber.addClass('error');
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class=\'icon-exclamation\'>'+response.responseJSON.Error +'</p>');
        });
      }
      // Generate errors for UploadInfringementExtension
      if(!invalid && COVIDReferenceNumber.val() !== '' && option == 'UploadInfringementExtension'){
        $.when(checkInfringementExtensionEligibility(COVIDReferenceNumber.val())).done(function(res){
          if(!res){
            COVIDReferenceNumber.addClass('error');
            invalid = true;
            covidConcessionErrorList
              .show()
              .append('<p class=\'icon-exclamation\'>Please enter a valid obligation or infringement number.</p>');
          }
        }).fail(function (response) {
          COVIDReferenceNumber.addClass('error');
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class=\'icon-exclamation\'>'+response.responseJSON.Error +'</p>');
        });
      }


	  if ((!$('#other-options').is(':disabled') && $('#other-options').val() == '') || (!$('#followup-options').is(':disabled') && $('#followup-options').val() == '')) {
		  $('#followup-options,#other-options').addClass('error');
		  invalid = true;
		  covidConcessionErrorList
		  	  .show()
			  .append('<p class="icon-exclamation">Please select a Request type</p>');
	  }

      // if no option selected, will return generic config
      let {allowedNumOfFiles,allowedFileSize} = getSelectedFilesConfig(option);
	  
      var $size = 0;
      var $validFile = true;
      var _validFileExtensions = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/msword','image/jpeg','image/png','application/pdf','text/plain'];  
	  	//file size and extension check here
      $('.inputfile').each(function () {
        if ($(this).val() != '') {
          var i;
          for (i = 0; i < this.files.length; i++) { 
				  $size += this.files[i].size;
				  if (!_validFileExtensions.includes(this.files[i].type) || this.files[i].name.endsWith('.rtf')){
					  $validFile = false;
				  }
          }				
        }
			
        if (this.files.length == 0){
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation">File attachment is required.</p>');
        }
        else if (this.files.length > allowedNumOfFiles) {
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation">A maximum of '+ allowedNumOfFiles +' files can be attached.</p>');
        }
        else if ($size > allowedFileSize){
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation">One or more files is too large. Files should be '+parseFloat(bytesToSize(allowedFileSize))+'MB or less.</p>');
        }
        else if (!$validFile){
          invalid = true;
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation">One or more attachments is not an allowed file type. Only PDF, Word, Excel, PNG, JPG, Text are allowed.</p>');
        }
			 
      });
    };
    $('.online-enquiry-form > #EnquiryType, .online-enquiry-form > .enquiry-details, .online-enquiry-form > #attachmentSection,.online-feedback-form').find('input,textarea').focusout(function(){
      if(!$(this).is(':invalid')){
        $(this).removeClass('error');
      }
    });
    
    $('.online-enquiry-form select').change(function(){
      $(this).removeClass('error');
    });

    $('.online-enquiry-form .btn, .online-feedback-form .btn').on('click', function () {

      if(!$(this).hasClass('pay')){
        var option = $('#other-options').val();
        if(option && option != ''){
          showCovidConcessionSectionErrorMessages();
        }
        else {
          showAllErrorMessages();
        }
        if (invalid) {
          $('html,body').animate({
            scrollTop: $(errorList).offset().top - 100
          }, 'fast');
          return false;
        }
      }
      
    });

  };

  createAllErrors();

  var setOnlineEnquiryURLParameters = function(type, sub) {
    var currentUrl = new URL(window.location.href);
    var search_params = currentUrl.searchParams;
    if(type){
      search_params.set('type', type);
      search_params.set('sub', '');
    }
    if(sub){
      search_params.set('sub', sub);
    }
    currentUrl.search = search_params.toString();
    if(!type && !sub){
      window.history.pushState({}, '', window.location.href.split('?')[0]);
    }
    else{
      window.history.pushState({}, '', currentUrl.search);
    }
    
  };
  var adjustContentFileUpload = function(option) {
    const form = $('.online-enquiry-form');
    const covidConcessionErrorList = $('div.file-section-error-message', form);
    covidConcessionErrorList.hide();
    $('#attachmentInfo').text(onlineGenericFileDescription);
    switch(option) {
    case 'UploadCovidConcession':
      $('#FileUploadTitle').text('Concession scheme for COVID-19 Fines – form upload');
      $('#FileUploadContent').html('<p>Please upload your completed COVID-19 fine concession application form <strong>and</strong> a clear photo/scan of your concession card.</p> <span><a href="/Support/concession" style="color:#00a9e1" target="_blank">More about the concession scheme for COVID-19 fines.</a></span>');
      $('#attachmentInfo').text(getSelectedFilesConfig(option).description);
      break;
    case 'OnlineEnquirySeatbelt':
      $('#FileUploadTitle').text('Seatbelt exemption statement');
      $('#FileUploadContent').html('<p>Please enter your obligation number and attach your seatbelt exemption statement, along with any files or documents to support your claim.</br></br>If your fine has reached Notice of Final Demand or Warrant stage, your claim will be processed as an <b>Enforcement Review</b> application on the ground of Contrary to law.</br></br>Read more about <a href="/Support/Seatbelt-Exemption" style="color: #00a9e1" target="_blank">Seatbelt exemption claims</a>.</p>');
      $('#attachmentInfo').text(getSelectedFilesConfig(option).description);
      break;
    case 'UploadNomination':
      $('#FileUploadTitle').text('Nominate a driver');
      $('#FileUploadContent').html('<p>If you were not driving or in possession of your vehicle at the time of the offence, you should tell us who was driving.</p>');
      break;
    case 'UploadReview':
      $('#FileUploadTitle').text('Request a review');
      $('#FileUploadContent').html('<p>If you believe there is a valid reason why your fine should be withdrawn, you may be able to ask for it to be reviewed.</p>');
      break;
    case 'UploadInstalment':
      $('#FileUploadTitle').text('Request to pay by instalments');
      $('#FileUploadContent').html('<p>If you can\'t pay your fine in full by the due date, you can ask to pay it off in instalments. This is known as a payment arrangement.</p>');
      break;
    case 'UploadExtention':
      $('#FileUploadTitle').text('Request a payment extension');
      $('#FileUploadContent').html('<p>If you\'ve received a fine and can\'t pay the full amount by the due date, you can ask for more time to pay.</p>');
      break;
    case 'UploadCourtRequest':
      $('#FileUploadTitle').text('Dispute your fine in court');
      $('#FileUploadContent').html('<p>If you have been issued with an infringement notice, you can choose to have the matter heard in court.</p>');
      break;
    case 'UploadThirdParty':
      $('#FileUploadTitle').text('Authorise another person to help manage your fines');
      $('#FileUploadContent').html('<p>If you cannot deal with your fines on your own, you can authorise another person to help you manage your fines.</p>');
      break;
    case 'UploadCourtExtract':
      $('#FileUploadTitle').text('Submit a court extract');
      $('#FileUploadContent').html('<p>If you have been granted an infringement extension by a Magistrate, you can submit the court extract to arrange for more time to deal with that fine (if it is managed by Fines Victoria).');
      break;
    case 'UploadFinancialCircumstances':
      $('#FileUploadTitle').text('Statement of financial circumstances');
      $('#FileUploadContent').html('<p>If the Director, Fines Victoria has directed you to produce information about your financial circumstances, please upload your completed statement of financial circumstances and supporting documentation here.</p>');
      $('#attachmentInfo').text(getSelectedFilesConfig(option).description);
      break;
    case 'UploadInfringementExtension':
      $('#FileUploadTitle').text('Infringement extension');
      $('#FileUploadContent').html('<p>Please upload your completed Infringement Extension Form and Statutory Declaration. You can download these from the <span><a href="/Your-options/Find-a-form" style="color:#00a9e1" target="_blank">Find a form</a> page and complete. The statutory declaration must be signed in the presence of an authorised witness.</p><p>You may also attach any accompanying application forms, such as a completed nomination statement or court request, or any other relevant supporting documents.</p>');
      $('#attachmentInfo').text(getSelectedFilesConfig(option).description);
      break;
    }
    
  };
  //online enquiry form levels of selection hide and show
  var existingOnlineEnquiryRequired = '';
  var resetFieldsOnYoureDetails = function () {
    $('#COVIDReferenceNumber').removeAttr('required');
    if(existingOnlineEnquiryRequired){
      if($('.state-dropdown').find(':selected').text() == ''){
        $('.state-dropdown').val('VIC');
        $('.state-input').val('VIC');
        $('.country-input').val('AUS');
        $('.country-dropdown').val('AUS');
      }
      existingOnlineEnquiryRequired.each(function(i, current){
        //ignore residential state address when option changes since it's hidden when loads
        if(current.name != 'ResidentialState'){
          $(current).attr('required', true);
        }
      });
    }
  };

  var followUpOptionOnChange = function () {
    var option = $('#followup-options').val();
    if(!option) return;
    if(option && option != ''){
      switch(option){
      case 'Other':
        setOnlineEnquiryURLParameters('other', 'SomethingElse');
        break;
      default:
        setOnlineEnquiryURLParameters('', '');
      }
      
    }
  };
  
  var requestTypeButtonChecked = function () {
    if($('#newRequest').is(':checked')){
      setOnlineEnquiryURLParameters('','');
      $('#other-options').val('');
      $('#followup-options').val('');
      $('.second-enquiry').hide();
      $('.second-enquiry select').attr('disabled',true);
  
      $('.newRequest').show();
      $('.newRequest select').removeAttr('disabled');
  
      $('.enquiry-details').hide();
      $('#attachmentSection').hide();
      $('.covidConcessionSection').hide();
      
     
    }
    else if($('#followup').is(':checked')){
      setOnlineEnquiryURLParameters('','');
      resetFieldsOnYoureDetails(); //if return from other forms like COVID Concession
      $('#other-options').val('');
      $('#newRequest-options').val('');
      $('.second-enquiry').hide();
      $('.second-enquiry select').attr('disabled',true);
  
      $('.followup').show();
      $('.followup select').removeAttr('disabled');
  
      $('.enquiry-details').hide();
      $('#attachmentSection').hide();
      $('.covidConcessionSection').hide();
    }
    else{
      setOnlineEnquiryURLParameters('other', '');
      $('#newRequest-options').val('');
      $('#followup-options').val('');
      $('.second-enquiry').hide();
      $('.second-enquiry select').attr('disabled',true);
  
      $('.other').show();
      $('.other select').removeAttr('disabled');
  
      $('.enquiry-details').hide();
      $('#attachmentSection').hide();
      $('.covidConcessionSection').hide();
    }
  };
  let resetFileUpload = function (){
    globalFilesArray = new DataTransfer();
    $('.inputfile').val('');
    $('ul#fileItemList').empty();
    $('#fileUploadLabel').text('Drag and drop, or choose file(s)');
    $('.file-upload').css('border','solid 1px #dddddd');
    
  };
  $('form .asbutton').on('click', function () {
    $('.other-link-to-newRequest p').hide();
    $('.other-link-to-newRequest .btn').hide();
    $('#attachmentInfo').text(onlineGenericFileDescription);
    if (window.location.href.indexOf('Online-enquiry') > 0){
      resetFileUpload();
    }
    requestTypeButtonChecked();
  
  });
  $('#followup-options').change(function(){
    followUpOptionOnChange();
    $('.enquiry-details').show();
    $('#attachmentSection').show();
  });
  $('#followup-options option').on('click', function(){
   
    $('.enquiry-details').show();
    $('#attachmentSection').show();
  });

  var otherOptionOnChange = function () {
    var option = $('#other-options').val();
    if(!option) return;
    if(option && option != ''){
      switch(option){
      case 'UploadCovidConcession':
        setOnlineEnquiryURLParameters('', 'CovidConcession');
        break;
      case 'UploadNomination':
        setOnlineEnquiryURLParameters('', 'Nomination');
        break;
      case 'UploadReview':
        setOnlineEnquiryURLParameters('', 'Review');
        break;
      case 'UploadInstalment':
        setOnlineEnquiryURLParameters('', 'Instalment');
        break;
      case 'UploadExtention':
        setOnlineEnquiryURLParameters('', 'Extention');
        break;
      case 'UploadCourtRequest':
        setOnlineEnquiryURLParameters('', 'CourtRequest');
        break;
      case 'UploadThirdParty':
        setOnlineEnquiryURLParameters('', 'ThirdParty');
        break;
      case 'UploadCourtExtract':
        setOnlineEnquiryURLParameters('', 'CourtExtract');
        break;
      case 'OnlineEnquirySeatbelt':
        setOnlineEnquiryURLParameters('', 'Seatbelt-exemption-statement');
        break;
      case 'UploadFinancialCircumstances':
        setOnlineEnquiryURLParameters('', 'statement-financial-circumstances');
        break;
      case 'UploadInfringementExtension':
        setOnlineEnquiryURLParameters('', 'infringement-extension');
        break;
      }
      adjustContentFileUpload(option);
      $('#COVIDReferenceNumber').attr('required', true);
      existingOnlineEnquiryRequired = $('.enquiry-details').find('input:required,textarea:required,select:required');
      $('.enquiry-details').find('input,textarea,select').each(function(i, current){
        $(current).removeAttr('required');
      });
      $('.enquiry-details').hide();
      $('.covidConcessionSection').show();
      $('#attachmentSection').show();
    }
  };
  
  $('#other-options').change(function(){
    resetFileUpload();
    $('.other-link-to-newRequest .btn').hide();
    otherOptionOnChange();
  });
  $('#other-options option').on('click', function(){
    var option = $(this).val();
    if(option != 'NominateADriver' && option != 'RequestAReviewOfYourFine' && option != 'RequestAnExtensionOfTimeToPay' && option != 'UploadCovidConcession'){
      $('.enquiry-details').show();
      $('#attachmentSection').show();
    }
  });
  $( '#newRequest-options').on('change', function(){
    var option = $(this).val();
    //the paragraph, button text and button href for different options
    var b1 = 'Continue';
    var h1 = '/Your-options/Pay-your-fine';
    var h2 = '/Your-options/Request-to-pay-by-instalments';
    var h3 = '/Your-options/Request-a-payment-extension';
    var h4 = '/Your-options/Check-your-payments';
    var h5 = '/Your-options/Nominate-driver';
    var h6 = '/Your-options/Request-a-review';
    var h7 = '/Your-options/Dispute-your-fine-in-court';
    var h8 = '/Your-options/View-the-photo-of-your-offence';
    var h9 = '/Your-options/If-you-didnt-know-about-your-fine';
    var h10 = '/Your-options/Fine-amounts-and-demerit-points';
    var h11 = '/Your-options/Update-your-address';
    if(option == ''){
      $('.link-to-newRequest p').hide();
      $('.link-to-newRequest .btn').hide();
    }
    else{
      $('.link-to-newRequest p').show();
      $('.link-to-newRequest .btn').show();
    }
    switch (option){
    case 'pay':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h1);
      break;
    case 'instalment':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h2);
      break;
    case 'extension':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h3);
      break;
    case 'checkPayment':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h4);
      break;
    case 'nominate':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h5);
      break;
    case 'review':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h6);
      break;
    case 'court':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h7);
      break;
    case 'view-image':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h8);
      break;
    case 'notKnowYourFine':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h9);
      break;
    case 'findOutFineDetails':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h10);
      break;
    case 'updateAddress':
      $('.link-to-newRequest .btn').text(b1);
      $('.link-to-newRequest .btn').attr('href', h11);
      break;
    }
  });

  //dynamically populate dropdown based off url parameters
  if(onlineEnquiryType && onlineEnquirySub) {
    if(onlineEnquiryType == 'other' && onlineEnquirySub != 'SomethingElse'){
      $('#other').attr('checked', 'checked');
      requestTypeButtonChecked();
      switch(onlineEnquirySub) {
      case 'CovidConcession':
        $('#other-options').val('UploadCovidConcession');
        break;
      case 'Nomination':
        $('#other-options').val('UploadNomination');
        break;
      case 'Review':
        $('#other-options').val('UploadReview');
        break;
      case 'Instalment':
        $('#other-options').val('UploadInstalment');
        break;
      case 'Extention':
        $('#other-options').val('UploadExtention');
        break;
      case 'CourtRequest':
        $('#other-options').val('UploadCourtRequest');
        break;
      case 'ThirdParty':
        $('#other-options').val('UploadThirdParty');
        break;
      case 'CourtExtract':
        $('#other-options').val('UploadCourtExtract');
        break;
      case 'Seatbelt-exemption-statement':
        $('#other-options').val('OnlineEnquirySeatbelt');
        break;
      case 'statement-financial-circumstances':
        $('#other-options').val('UploadFinancialCircumstances');
        break;
      case 'infringement-extension':
        $('#other-options').val('UploadInfringementExtension');
        break;
       
      }
      otherOptionOnChange();
    }
    else if(onlineEnquirySub == 'SomethingElse' && onlineEnquiryType == 'other'){
      $('#followup').attr('checked', 'checked');
      requestTypeButtonChecked();
      setOnlineEnquiryURLParameters('other', 'SomethingElse');
      $('#followup-options').val('Other');
      $('.enquiry-details').show();
      $('#attachmentSection').show();
    }
  }
  //the attributes below only restrict html validation without any error reminder
  //for 5000 characters message limits
  //$('#Message').attr('maxlength', "5000" );
  
  $('#PhoneNumber').attr('maxlength', '20');
  $('#PrisonPhoneNumber').attr('pattern', '[0-9]{8,14}');
  $('#PrisonPhoneNumber').attr('onkeydown', 'return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106) || (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46) )');
  $('#LicenceNumber').attr('maxlength', '25');
  $('#Postcode').attr('maxlength', '10');
  $('input[type=email]').bind('cut copy paste', function (e) {
    e.preventDefault();
  });
  if ($('#PostalCountry').val() === 'AUS') {
    $('#Postcode').attr('pattern', '[0-9]{4}');
    $('#Postcode').attr('maxlength', '4');
  }
  if ($('#ResidentialCountry').val() === 'AUS') {
    $('#ResidentialPostcode').attr('pattern', '[0-9]{4}');
    $('#ResidentialPostcode').attr('maxlength', '4');
  }

  //survey form
  var createSurveyFormErrors = function () {

    var form = $('.survey-form');
    var errorList = $('div.error-message', form);
    var invalid = false;
    errorList.hide();
    var showAllErrorMessages = function () {
      invalid = false;
      errorList.empty();

      //Find all invalid fields within the form.
      form.find('.error').each(function (index, node) {
        invalid = true;
        errorList
          .show()
          .append('<p class="icon-exclamation">' + $(this).attr('data-message') + '</p>');
      });
    };

    $('.survey-form input, .survey-form textarea').keypress(function (e) {

      var count = e.target.value.split(' ').length;
      var length = $(this).attr('data-length');
      if (typeof length !== 'undefined' && count > length)
        $(this).addClass('error');

      else
        $(this).removeClass('error');
    });

    $('.survey-form input, .survey-form textarea').blur(function (e) {
      var count = e.target.value.split(' ').length;
      var length = $(this).attr('data-length');
      if (typeof length !== 'undefined' && count > length)
        $(this).addClass('error');

      else
        $(this).removeClass('error');
    });

    $('.survey-form .btn').on('click', function () {
      showAllErrorMessages();
      if (invalid) {
        $('html,body').animate({
          scrollTop: $(errorList).offset().top - 100
        }, 'fast');
        return false;
      }
    });

  };

  createSurveyFormErrors();
  var isOnlineEnquiry = window.location.href.indexOf('Online-enquiry') > 0;
  let removeFileItem = function (files, id) {
    var tempFilesList = new DataTransfer();;
    let index = 0;
    for(const file of files){
      if(index != id)
        tempFilesList.items.add(file);
      index++;
    }
    if(tempFilesList.files.length == 0){
      $('ul#fileItemList').hide();
    }
    return tempFilesList;
  };
  let validateMaxfileNum = function (selected, existing) {
    let form = $('.online-enquiry-form').length ? $('.online-enquiry-form') : $('.online-feedback-form');
    let covidConcessionErrorList = $('.covidConcessionSection').is(':visible') ? $('div.file-section-error-message', form) : $('div.error-message', form);
    let option = $('#other-options').val();
    covidConcessionErrorList.empty();
    let valid = false;
    //logic updated for phase 3 after file upload and phase 3 merge
    let maxFileNumAllowed = getSelectedFilesConfig(option).allowedNumOfFiles;
    if((selected + existing) < parseInt(maxFileNumAllowed) + 1)
      return valid;
    let currentError = $('.invalidMaxFileNum', covidConcessionErrorList).length;
    if(currentError == 0){
      covidConcessionErrorList
        .show()
        .append('<p class="icon-exclamation invalidMaxFileNum">File attachments exceeded allowed number, only a maximum of '+ maxFileNumAllowed +' attachments can be included.</p>');
      
    }
   
    if (!valid) {
      $('html,body').animate({
        scrollTop: $(covidConcessionErrorList).offset().top - 100
      }, 'fast');
    }
    return true;
  };
  let updateFileUploadLabel = function (tempFilesArray, attachmentField) {
    var fileName = '';
    if (tempFilesArray.files && tempFilesArray.files.length > 1)
      fileName = (attachmentField.getAttribute('data-multiple-caption') || '').replace('{count}', tempFilesArray.files.length);
    else if (tempFilesArray.files && tempFilesArray.files.length == 1 && tempFilesArray.files[0].name)
      fileName = tempFilesArray.files[0].name;
    else if (tempFilesArray.files && tempFilesArray.files.length == 0 && attachmentField.files && attachmentField.files.length > 1)
      fileName = (attachmentField.getAttribute('data-multiple-caption') || '').replace('{count}', attachmentField.files.length);
    else if (tempFilesArray.files && tempFilesArray.files.length == 0 && attachmentField.files && attachmentField.files.length == 1)
      fileName = attachmentField.files[0].name;

    if (fileName){
      $('#fileUploadLabel').text('Drag and drop, or choose file(s)');
      if(isOnlineEnquiry)
        $('.file-upload').css('border','solid 1px #dddddd');
    }
    else{
      $('#fileUploadLabel').text('Drag and drop, or choose file(s)');
        
    }
  };
  let appendFileList = function (tempFilesArray) {
    $('ul#fileItemList').empty();
    if(tempFilesArray.files.length == 0){
      return;
    }
    let index = 0;
    for(const file of tempFilesArray.files){
      $('#fileItemList').append('<li id='+ index  +'> <div class="itemContainer">'+ file.name +'</div><a aria-label="click to remove selected file" class="remove removeButton" href="javascript:void(0);"><svg class="removeIcon" width="26" height="26" viewBox="0 0 26 26" xmlns="https://www.w3.org/2000/svg"><path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"></path></svg></a></li>');//.hide().fadeIn(999);
      index++;
    }
    $('ul#fileItemList').on('click', '.remove', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      let attachmentField = document.querySelector('.inputfile');
      $(this).closest('li').remove();
      let getUpdatedFileItems = removeFileItem(globalFilesArray.files, $(this).closest('li').prop('id'));
      appendFileList(getUpdatedFileItems);
      attachmentField.files = getUpdatedFileItems.files;
      globalFilesArray.clearData();
      for(const file of attachmentField.files){
        globalFilesArray.items.add(file);
      }
      updateFileUploadLabel(getUpdatedFileItems, attachmentField);
    });
    $('ul#fileItemList').show();
  };
  let fileUploadValidation = function (selectedFiles) {
    if(selectedFiles && selectedFiles.files && selectedFiles.files.length == 0){
      return;
    }
    let form = $('.online-enquiry-form').length ? $('.online-enquiry-form') : $('.online-feedback-form');
    let covidConcessionErrorList = $('.covidConcessionSection').is(':visible') ? $('div.file-section-error-message', form) : $('div.error-message', form);
    if($('.invalidMaxFileNum').length == 0)
      covidConcessionErrorList.empty();
    var $size = 0;
    var $validFile = true;
    let invalid = false;
    let option = $('#other-options').val();
    //logic updated for phase 3 after file upload and phase 3 merge
    let {allowedNumOfFiles,allowedFileSize} = getSelectedFilesConfig(option);
    
    var _validFileExtensions = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/msword','image/jpeg','image/png','application/pdf','text/plain'];  
	  	//file size and extension check here
    if (selectedFiles && selectedFiles.files && selectedFiles.files.length > 0) {
      var i;
      for (i = 0; i < selectedFiles.files.length; i++) { 
				  $size += selectedFiles.files[i].size;
				  if (!_validFileExtensions.includes(selectedFiles.files[i].type) || selectedFiles.files[i].name.endsWith('.rtf')){
					  $validFile = false;
				  }
      }				
    }
			
    if (selectedFiles && selectedFiles.files && selectedFiles.files.length == 0){
      invalid = true;
      covidConcessionErrorList
        .show()
        .append('<p class="icon-exclamation">File attachment is required.</p>');
    }
    else if (selectedFiles && selectedFiles.files && selectedFiles.files.length > allowedNumOfFiles) {
      invalid = true;
      let currentError = $('.invalidMaxFileNum', covidConcessionErrorList).length;
      if(currentError == 0){
        covidConcessionErrorList
          .show()
          .append('<p class="icon-exclamation invalidMaxFileNum">A maximum of '+ allowedNumOfFiles +' files can be attached.</p>');
      }
    }
    else if ($size > allowedFileSize){
      invalid = true;
      covidConcessionErrorList
        .show()
        .append('<p class="icon-exclamation">One or more files is too large. Files should be '+parseFloat(bytesToSize(allowedFileSize))+'MB or less.</p>');
        
    }
    else if (!$validFile){
      invalid = true;
      covidConcessionErrorList
        .show()
        .append('<p class="icon-exclamation">One or more attachments is not an allowed file type. Only PDF, Word, Excel, PNG, JPG, Text are allowed.</p>');
        
    }
    if (invalid) {
      $('html,body').animate({
        scrollTop: $(covidConcessionErrorList).offset().top - 100
      }, 'fast');
    }
    return invalid;
  };
  //custom upload
  (function ($, window, document, undefined) {
    $('.inputfile').each(function () {
      var $input = $(this),
        $label = $input.next('label'),
        labelVal = $label.html();

      $input.on('change', function (e) {
        var fileName = '';
        if($('.online-feedback-form').length){
          globalFilesArray.clearData();
        }
        let isValidMaxNum = validateMaxfileNum(this.files.length, globalFilesArray.files.length);
        if(fileUploadValidation(this) || isValidMaxNum){
          updateFileUploadLabel(globalFilesArray, this);
          return;
        }
        else {
          let form = $('.online-enquiry-form').length ? $('.online-enquiry-form') : $('.online-feedback-form');
          let covidConcessionErrorList = $('.covidConcessionSection').is(':visible') ? $('div.file-section-error-message', form) : $('div.error-message', form);
          covidConcessionErrorList.hide();
          covidConcessionErrorList.empty();
        }
        if(this.files && this.files.length > 1){
          for(const file of this.files){
            globalFilesArray.items.add(file);
          }
        }
        else if(this.files && this.files.length == 1){
          globalFilesArray.items.add(this.files[0]);
        }
        if (this.files && this.files.length > 1)
          fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        else if (e.target.value)
          fileName = e.target.value.split('\\').pop();

        if (fileName)
          $label.find('span').html(fileName);
        else
          $label.html(labelVal);
        this.files = globalFilesArray.files;
        appendFileList(globalFilesArray);
        updateFileUploadLabel(globalFilesArray, this);
      });
     
      // Firefox bug fix
      $input
        .on('focus', function () {
          $input.addClass('has-focus');
        })
        .on('blur', function () {
          $input.removeClass('has-focus');
        });
    });
  })(jQuery, window, document);
  if(isOnlineEnquiry){
    let dropAreaTextControl = 0;
    var enquiryDragDrop = $('.file-upload');
    if(enquiryDragDrop.length > 0){
      $('.file-upload').after('<ul id="fileItemList" class="ulContainer"></ul>');
      $('#fileItemList').hide();
    }
    enquiryDragDrop.on('dragenter', function (e) {
      dropAreaTextControl++;
      e.stopPropagation();
      e.preventDefault();
      if(isOnlineEnquiry)
        $('.file-upload').css('border','solid 1px #004FAB');
    });
    enquiryDragDrop.on('dragover', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    enquiryDragDrop.on('dragleave', function (e) {  
      dropAreaTextControl--;
      e.stopPropagation();
      e.preventDefault();
      if(dropAreaTextControl == 0 && isOnlineEnquiry){
        $('.file-upload').css('border','solid 1px #dddddd');
      }
    });
  
    enquiryDragDrop.on('drop', function (e) {
      e.stopPropagation();
      e.preventDefault();
      dropAreaTextControl = 0;
      let tempFilesArray = new DataTransfer();;
      let attachmentField = document.querySelector('.inputfile');
      let files = e.originalEvent.dataTransfer.files;
      let isValidMaxNum = validateMaxfileNum(e.originalEvent.dataTransfer.files.length, globalFilesArray.files.length);
      if(fileUploadValidation(e.originalEvent.dataTransfer) || isValidMaxNum){
        updateFileUploadLabel(tempFilesArray, attachmentField);
        return;
      }
      else {
        let form = $('.online-enquiry-form');
        let covidConcessionErrorList = $('.covidConcessionSection').is(':visible') ? $('div.file-section-error-message', form) : $('div.error-message', form);
        covidConcessionErrorList.hide();
        covidConcessionErrorList.empty();
      }
      $('#fileItemList').show();
      if(attachmentField.files.length >= 1){

        for(const file of attachmentField.files){
          tempFilesArray.items.add(file);
        }
        for(const file of files){
          tempFilesArray.items.add(file);
        }
      }
      else {
        if(files.length > 1){
          for(const file of files){
            tempFilesArray.items.add(file);
          }
        }
        else{
          tempFilesArray.items.add(files[0]);
        }
        
      }
      appendFileList(tempFilesArray);
      updateFileUploadLabel(tempFilesArray, attachmentField);
      attachmentField.files = tempFilesArray.files;
      /// update files to global
      globalFilesArray.clearData();
      for(const file of attachmentField.files){
        globalFilesArray.items.add(file);
      }
    });
  }
  //personlization submit feedback
  $('.completed form .asbutton [name="feedback"]').on('change', function () {
    $('.completed form .asbutton p').hide();
    $(this).siblings('p').show();
    $('.address1').css('display', 'none');
  });

  //address validation on contact page
  $('.notAU').change(function () {
    var parentWrapper = $(this).closest('.address-wrapper');
    
    if ($(this).is(':checked')) { 
      parentWrapper.find('.address2').css('display', 'flex');
      parentWrapper.find('.address1').css('display', 'none');
      parentWrapper.find('.country-dropdown').show();
      parentWrapper.find('.country-input').css('display','none');
      parentWrapper.find('.country-input').removeAttr('required');
      parentWrapper.find('.main-address').removeAttr('required');	  
      parentWrapper.find('.address2 input').prop('readonly', false);
      parentWrapper.find('.address2 .state-dropdown').prop('disabled', false);
      parentWrapper.find('.address2 .state-input').prop('disabled', false);
      parentWrapper.find('.state-input').show();
      parentWrapper.find('.state-dropdown').hide();
      //parentWrapper.find('#residential-address').removeAttr('required');	 
    }
    else {
      parentWrapper.find('.address2').css('display', 'none');
      parentWrapper.find('.address1').css('display', 'block');
      parentWrapper.find('.country-dropdown').hide();
      parentWrapper.find('.country-input').show();
      parentWrapper.find('.country-input').prop('required',true);
      parentWrapper.find('.main-address').prop('required',true);
      parentWrapper.find('.address2 input').prop('readonly', true);
      parentWrapper.find('.address2 .state-dropdown').prop('disabled', true);
      parentWrapper.find('.address2 .state-input').prop('disabled', true);
      parentWrapper.find('.state-input').hide();
      parentWrapper.find('.state-dropdown').show();
      //$('#residential-address').prop('required',true);
    }
    if( $('.online-feedback-form').length > 0){
      onlineFeedback.toogleAddressMandatory();
    }
    
  });
  //address validation on contact page
  $('#ResidentialSameAsPostal').change(function () {
    if ($(this).is(':checked')) { 
      $('.residential-address').hide();
      $('#residential-address-line-1').removeAttr('required');
      $('#ResidentialSuburb').removeAttr('required');
      $('#ResidentialPostcode').removeAttr('required');
      $('#ResidentialStateInternational').removeAttr('required');
      $('#residential-address').removeAttr('required');	 
      $('#ResidentialCountryInput').removeAttr('required');
    }
    else {
      $('.residential-address').show();
      $('#residential-address-line-1').prop('required',true);
      $('#ResidentialSuburb').prop('required',true);
      $('#ResidentialPostcode').prop('required',true);

      if($('#ResidentialCountry').val() !== 'AUS'){
        $('#ResidentialStateInternational').prop('required',true);
      }
      if(!$('#residential-notAu').is(':checked')){
        $('#residential-address').prop('required',true);
        $('#ResidentialCountryInput').prop('required',true);
      }
    }
  });



  $('.re-check').on('click', function () {
    var parentWrapper = $(this).closest('.address-wrapper');
    parentWrapper.find('.address2').css('display', 'none');
    parentWrapper.find('.address1').css('display', 'block');
    parentWrapper.find('.country-dropdown').hide();
    parentWrapper.find('.country-input').show();
    parentWrapper.find('.main-address').prop('required',true);
    parentWrapper.find('.notAU').prop('checked', false);
    parentWrapper.find('.state-input').hide();
    parentWrapper.find('.state-dropdown').show();
    parentWrapper.find('.address2 .state-dropdown').prop('disabled', false);

    //$('#residential-address').prop('required',true);
    if( $('.online-feedback-form').length > 0){
      onlineFeedback.toogleAddressMandatory();
    }
  });

  //var token = '10b31523-f0af-4367-a7cd-0c01bc2752c7';
  var token = '7964f306-a4f4-4365-992b-1f63ea0da8a0';
  $('#postal-address, #residential-address').on('keyup', function () {
    var parentWrapper = $(this).closest('.address-wrapper');
    if ($('#postal-address').val().length > 4 || $('#residential-address').val().length > 4) {
      var address = $(this).val();
      $.ajax({
        method: 'GET',
        url: 'https://api.edq.com/capture/address/v2/search',
        data: {
          'country': 'AUS',
          'query': address
        },
        headers: { 'Auth-Token': token },
        success: function (result) {
          parentWrapper.find('ul.address-list').empty();
          var addressContent = result.results;
          for (var i = 0; i < addressContent.length; i++) {
            parentWrapper.find('ul.address-list').append('<li data=' + i + ' class="list-item">' + addressContent[i].suggestion + '</li>');
          };
          parentWrapper.find('ul.address-list').append('<li style="border-bottom:1px solid #ddd; margin:0 20px; padding:0;"></li><li class="enterContactAddress"> Enter my address manually </li>');
          parentWrapper.find('.enterContactAddress').each(function () {
            $(this).on('click', function () {
              parentWrapper.find('ul.address-list').empty();
              parentWrapper.find('.country-dropdown').show();
              parentWrapper.find('.country-input').css('display','none');
              parentWrapper.find('.country-input').removeAttr('required');
              parentWrapper.find('.main-address').removeAttr('required');			  
              parentWrapper.find('.address2').css('display', 'flex');
              parentWrapper.find('.address1').css('display', 'none');
              parentWrapper.find('.address2 input').prop('readonly', false);
              parentWrapper.find('.address2 .state-dropdown').prop('disabled', false);
            });
          });

          parentWrapper.find('ul.address-list li.list-item').on('hover', function () {
            parentWrapper.find('.main-address').val($(this).text());
          });
          parentWrapper.find('ul.address-list li.list-item').on('click', function () {
            parentWrapper.find('.main-address').val($(this).text());
            parentWrapper.find('ul.address-list').empty();
            parentWrapper.find('.address2 input').removeClass('error');
            var index = $(this).attr('data');
            var apiUrl = addressContent[index].format;
            $.ajax({
              method: 'GET',
              url: apiUrl,
              headers: { 'Auth-Token': token },
              success: function (result) {
                parentWrapper.find('.country-dropdown').hide();
                parentWrapper.find('.address2').css('display', 'flex');
                parentWrapper.find('.address1').css('display', 'none');
                parentWrapper.find('.address2 input').prop('readonly', true);
                parentWrapper.find('.address2 .state-dropdown').prop('disabled', true);
                parentWrapper.find('.state-input').removeAttr('disabled');
                parentWrapper.find('.address-line-1').val(result.address[0].addressLine1);
                if (result.address[1].addressLine2 == '') {
                  parentWrapper.find('.address-line-2').hide();
                  parentWrapper.find('.line2').hide();
                }
                else {
                  parentWrapper.find('.address-line-2').val(result.address[1].addressLine2);
                }
                if (result.address[2].addressLine3 == '') {
                  parentWrapper.find('.address-line-3').hide();
                  parentWrapper.find('.line3').hide();
                }
                else {
                  parentWrapper.find('.address-line-3').val(result.address[2].addressLine3);
                }
                parentWrapper.find('.suburb-input').val(result.address[3].locality);
                parentWrapper.find('.state-dropdown').val(result.address[4].province);
                parentWrapper.find('.state-input').val(result.address[4].province);
                parentWrapper.find('.country-input').val(result.address[6].country);
                parentWrapper.find('.country-dropdown').val('Australia');
                parentWrapper.find('.postcode-input').val(result.address[5].postalCode);
              }
            });
          });
        }
      });
    }
    else {
      parentWrapper.find('ul.address-list').empty();
      parentWrapper.find('ul.address-list').append('<li class="moreInfo">Enter more information to narrow down your search</li>');
      parentWrapper.find('ul.address-list').append('<li style="border-bottom:1px solid #ddd; margin:0 20px; padding:0;"></li><li class="enterContactAddress"> Enter my address manually </li>');
      parentWrapper.find('.enterContactAddress').each(function () {
        $(this).on('click', function () {
          parentWrapper.find('.main-address').val('');
          parentWrapper.find('ul.address-list').empty();
          parentWrapper.find('.country-dropdown').show();
          parentWrapper.find('.country-input').hide();
          parentWrapper.find('.country-input').removeAttr('required');		 
          parentWrapper.find('.main-address').removeAttr('required');		  
          parentWrapper.find('.address2').css('display', 'flex');
          parentWrapper.find('.address1').css('display', 'none');
          parentWrapper.find('.address2 input').prop('readonly', false);
          parentWrapper.find('.address2 .state-dropdown').prop('disabled', false);
        });
      });
    }
  });
});

function synchReviewCheckboxes(){
  if ($('.checkboxes-lister.active .checkboxes-list input[type=checkbox]:not(:checked)').length > 0){
    // there is unchecked checkboxes
    $('.btn-request-review').attr('disabled',true);
    $('.btn-request-review').addClass('disabled');
  }
  else{
    // there is no unchecked checkboxes
    $('.btn-request-review').removeAttr('disabled');
    $('.btn-request-review').removeClass('disabled');
  }
};

$('.checkboxes-list input[type=checkbox]').change(function(){
  synchReviewCheckboxes();
});
//review-page
$('.review-agreement-content [name=review-radio]').change(function(){

  $('.content-body').hide();
  $('.content-body').removeClass('active');
  $('.checkboxes-lister').removeClass('active');
  $('.review-agreement-content .checkboxes-lister [type=checkbox]').prop('checked', false);

  synchReviewCheckboxes();

  if($(this).prop('checked',true)){
    var parent = $(this).parent();

    //get the item order
    var tabIndex = $('.asbutton').index(parent);
    //show item which has the same order with the tabIndex
    var shownElement = $('.review-agreement-content .content-body:nth-child('+(tabIndex + 1)+')');
    //show the corresponding checkboxes
    var activeCheckbox = $('.review-agreement-content .checkboxes-lister:nth-child('+(tabIndex + 1)+')');

    activeCheckbox.addClass('active');
    shownElement.addClass('active');
    shownElement.show();
    $('.btn-review').show();
    $('.review-up').show();
    $('.btn-request-review').attr('disabled',true);

  }
});

document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', (e) => {
    // Prevent if already submitting
    if (form.classList.contains('is-submitting')) {
      e.preventDefault();
    }
    // Add class to hook our visual indicator on
    form.classList.add('is-submitting');
  });
});

$(document).ready(function(){
  $('.online-enquiry-form').on('submit', function (event) {
    event.preventDefault();
    $('.online-enquiry-form,.online-feedback-form,.prison-program-form').find(':submit').prop('disabled', true);
    var formData = new FormData(this);
    let form = $('.online-enquiry-form');
    let covidConcessionErrorList = $('.covidConcessionSection').is(':visible') ? $('div.file-section-error-message', form) : $('div.error-message', form);
    $.ajax({
      type: 'POST',
      url: window.location.origin + '/api/sitecore/OnlineEnquiry/OnlineEnquiryFormProcess',
      data: formData,
      contentType: false,
      processData: false,
      dataType: 'json'})
      .done(function (response) {
        if(response.status && response.status == "failure"){
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation invalidMaxFileNum">'+response.message +'</p>');
          $('html,body').animate({
            scrollTop: $(covidConcessionErrorList).offset().top - 100
          }, 'fast');
        }else {
          // Redirect to the new page
          if (response.redirectUrl)
            var currentDomain = window.location.protocol + "//" + window.location.host;
            var updatedUrl = response.redirectUrl?.replace(/^(https?:\/\/)[^\/]+/, currentDomain);
            window.location.href = updatedUrl;
        }        
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        // handle HTTP errors, including 404
        if (jqXHR.status === 404) {
          covidConcessionErrorList
            .show()
            .append('<p class="icon-exclamation invalidMaxFileNum">One or more attachments is not an allowed file type. Only PDF, Word, Excel, PNG, JPG and text files are allowed.</p>');
          $('html,body').animate({
            scrollTop: $(covidConcessionErrorList).offset().top - 100
          }, 'fast');
        }
      })
      .always(function() {
        $('.online-enquiry-form,.online-feedback-form,.prison-program-form').find(':submit').prop('disabled', false);
      });

  });
});












